import { IFinalEvent } from "types/event"
import {
    OptimizedEvent,
    AvailableTicket as OptimizedAvailableTicket,
} from "types/optimizedEvent"

type AnyAvailableTicket =
    | IFinalEvent["availableTickets"][number]
    | OptimizedAvailableTicket

const getEffectiveTicketPrice = (ticket: AnyAvailableTicket) => {
    if (!ticket) return Number.POSITIVE_INFINITY

    const hasDiscount =
        ticket.discount &&
        typeof ticket.discount.current_value === "number" &&
        ticket.discount.current_value > 0

    return hasDiscount ? ticket.discount.current_value : ticket.price
}

export const sortPrice = (list: IFinalEvent | OptimizedEvent) => {
    const tickets = list?.availableTickets as AnyAvailableTicket[] | undefined

    if (!tickets || tickets.length === 0) {
        return undefined
    }

    let cheapest = tickets[0]
    let lowest = getEffectiveTicketPrice(cheapest)

    for (let i = 1; i < tickets.length; i++) {
        const candidate = tickets[i]
        const candidatePrice = getEffectiveTicketPrice(candidate)

        if (candidatePrice < lowest) {
            lowest = candidatePrice
            cheapest = candidate
        }
    }

    // console.log(cheapest, "cheapest")

    return cheapest
}
